import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, TextStyle } from 'editor/src/store/design/types';

/** Changes the style itself only; rewriting its member texts is updateTextStyleOperation's job. */
const updateTextStyleReducer = (
  state: DesignState,
  action: PayloadAction<{ id: string; update: Partial<Omit<TextStyle, 'id'>> }>,
) => {
  const style = state.designData?.textStyles?.find(({ id }) => id === action.payload.id);
  if (style) {
    Object.assign(style, action.payload.update);
  }
};

export default updateTextStyleReducer;
